'use strict';
var novicell = novicell || {};

novicell.carrousel = novicell.carrousel || function () {

    function init() {
        siemaSlider();
    }

    function siemaSlider() {

        var siemaSelector = document.getElementsByClassName('siema-slider');
        
        for (var i = 0; i < siemaSelector.length; ++i) {

            const prev = document.querySelectorAll('.carrousel-controls--prev');
            const next = document.querySelectorAll('.carrousel-controls--next');

            // Init Siema slider
            const siema = new Siema ({
                selector: siemaSelector[i],
                perPage: {
                    100: 1,
                    768: 2
                },
                draggable: true,
                multipleDrag: true,
                onInit: function() {
                    let currentSlide = this.currentSlide;

                    if ( currentSlide == 0 ) {
                        prev[i].style.display = 'none';

                        if ( this.perPage == 1 ) {
                            next[i].style.left = '0';
                        }
                    }

                },
                onChange: function() {
                    const prev = document.querySelectorAll('.carrousel-controls--prev');
                    const next = document.querySelectorAll('.carrousel-controls--next');

                    let currentSlide = this.currentSlide;
                    let slideCount = this.innerElements.length;

                    if ( currentSlide == 0 ) {

                        prev[0].style.display = 'none';
                        next[0].style.display = 'flex';

                        if ( this.perPage == 1 ) {
                            next[0].style.left = '0px';
                        }

                    } else {

                        if ( ( currentSlide + this.perPage ) < slideCount ) {
                            next[0].style.display = 'flex';
                            prev[0].style.display = 'flex';

                            if ( this.perPage == 1 ) {
                                next[0].style.left = '50px';
                            }
                        } else {
                            next[0].style.display = 'none';
                            prev[0].style.display = 'flex';

                            if ( this.perPage == 1 ) {
                                next[0].style.left = '50px';
                            }
                        }

                    }
                }
            });
            
            for (var iC = 0; iC < prev.length; ++iC) {
                prev[i].addEventListener('click', () => siema.prev());
            }

            for (var iC = 0; iC < next.length; ++iC) {
                next[i].addEventListener('click', () => siema.next());
            }
        }
    }

    return {
        init : init,
        siemaSlider : siemaSlider
    };

}();